import React from 'react';
import { useProperty } from '../../hooks/useProperty';
import { useSteps } from '../../hooks/useSteps';
import { Helmet } from 'react-helmet';
import BackForwardButtons from '../../components/buttons/BackForwardButtons';
import PropertyMap from '../../components/PropertyMap';

// there is no map page except for on the sharing version
export default function PropertyMapPage() {
  const { propertyData } = useProperty();
  const type = propertyData?.projectType;
  const { prev, next } = useSteps(type);

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - Property Map</title>
      </Helmet>

      <div className="w-full mt-14"></div>
      <div className="w-full min-h-[600px]">
        <PropertyMap />
      </div>

      <div className="flex justify-between mt-7">
        <BackForwardButtons prev={prev} next={next} />
      </div>
    </>
  );
}
